import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type FloatingCTAProps = {
  anchorId: string;
};
export function FloatingCTA({
  anchorId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById(anchorId);
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, [anchorId]);
  return <AnimatePresence data-id="element-30" data-mp="2awcvk2k6gmrs">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 md:pb-5" data-id="element-31" data-mp="2atgzkjrw485z">
          <div className="mx-auto max-w-md" data-id="element-32" data-mp="2z2r2k7c2nz4e">
            <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-white bg-cta px-4 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_12px_32px_-6px_rgba(10,26,51,0.45)] hover:bg-cta-dark" data-id="element-33" data-mp="3342lxv4cro45">
              Get the Playbook — $27
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-34" data-mp="2fg2t8pnhdnmx" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}